import { ReactComponent as QuoteExpiredIcon } from '@basqet-dashboard/common/assets/icons/quote-expired.svg';
import { Button } from '@basqet-dashboard/common/components';
import PropTypes from 'prop-types';
import React from 'react';

import { QuoteCountdownRing } from './quote-countdown-ring';

const safeNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

const formatNumber = (value) =>
  safeNumber(value).toLocaleString('en-US', { maximumFractionDigits: 8 });

const ReviewStep = ({
  quote,
  reviewExchangeRate,
  bannerExpired,
  remainingSeconds,
  onRequote,
  onCancel,
  onConfirm,
  isSubmitting
}) => {
  if (!quote) return null;

  return (
    <div className="convert-step">
      <h3 className="convert-step__title">
        Review <span className="text-cursive">conversion</span>
      </h3>

      <dl className="convert-step__summary">
        <div className="convert-step__summary-row">
          <dt>You send</dt>
          <dd>
            {formatNumber(quote.from_amount)} {quote.from_currency}
          </dd>
        </div>
        <div className="convert-step__summary-row">
          <dt>You receive</dt>
          <dd className="convert-step__summary-value--positive">
            {formatNumber(quote.to_amount)} {quote.to_currency}
          </dd>
        </div>
        <div className="convert-step__summary-row">
          <dt>Exchange rate</dt>
          <dd>{reviewExchangeRate}</dd>
        </div>
      </dl>

      {!bannerExpired && remainingSeconds > 0 && (
        <div className="convert-step__countdown" role="status">
          <QuoteCountdownRing
            remainingSeconds={remainingSeconds}
            className="convert-step__countdown-icon"
          />
          <span>
            This quote expires in <strong>{remainingSeconds} seconds</strong>
          </span>
        </div>
      )}

      {bannerExpired && (
        <div className="convert-step__expired" role="alert">
          <QuoteExpiredIcon aria-hidden className="convert-step__expired-icon" />
          <span>The quote expired before confirmation. Generate a new quote.</span>
          <Button onClick={onRequote} disabled={isSubmitting}>
            Requote
          </Button>
        </div>
      )}

      <div className="convert-step__actions">
        <Button variant="outline" onClick={onCancel} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button onClick={onConfirm} disabled={isSubmitting || bannerExpired}>
          {isSubmitting ? 'Confirming…' : 'Confirm conversion'}
        </Button>
      </div>
    </div>
  );
};

ReviewStep.propTypes = {
  quote: PropTypes.shape({
    from_amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    to_amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    from_currency: PropTypes.string,
    to_currency: PropTypes.string
  }),
  reviewExchangeRate: PropTypes.string.isRequired,
  bannerExpired: PropTypes.bool,
  remainingSeconds: PropTypes.number,
  onRequote: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool
};

ReviewStep.defaultProps = {
  quote: null,
  bannerExpired: false,
  remainingSeconds: 0,
  isSubmitting: false
};

export { ReviewStep };
